import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IScoresStore } from './store';

export interface IScoresActions extends IActionGroup {
  get: (groupId: number) => { scores?: IScoresStore; errors?: IErrorsStore };
  save: (groupId: number, scores: any) => any;
  updateGame: (
    gameId: number,
    data: any,
    playerSignature?: Blob
  ) => { games?: IScoresStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  get: async (_: IStore, groupId: number) => {
    // if (Object.keys(state.games).length) {
    //   return { games: state.games };
    // }

    const response = await request.get(`${api.group(groupId)}games`);

    if (response.error) {
      return { errors: { games: { msg: 'Error retrieving the Games List.' } } };
    }

    return {
      scores: {
        [groupId]: response
      }
    };
  },
  save: async (state: IStore, groupId: number, data: any) => {
    const response = await request.patch(`${api.group(groupId)}scores`, {
      instances: Object.values(data)
    });
    // {original, game, hole}
    if (response.error) {
      return { errors: { games: { msg: 'Error updating the scores.' } } };
    }

    const groupScores = state.scores[groupId].reduce((acc, r) => ({ ...acc, [r.id]: r }), {});

    const newScores = response.reduce(
      (acc: any, r: any) => ({
        ...acc,
        [r.game]: {
          ...acc[r.game],
          scores: acc[r.game].scores.map((score: any) => (score.order === r.order ? r : score))
        }
      }),
      groupScores
    );

    return {
      scores: {
        [groupId]: Object.values(newScores)
      }
    };
  }
};

export default actions;
